import React from "react";
import { Box, FormControlLabel, Switch, TextField } from "@mui/material";
import { WorkflowCancelConfig } from "./workflowBuilderData";
import { useWorkflowReadOnly } from "./WorkflowReadOnlyContext";

interface WorkflowCancelPanelProps {
  config: WorkflowCancelConfig;
  onChange: (config: WorkflowCancelConfig) => void;
}

const WorkflowCancelPanel: React.FC<WorkflowCancelPanelProps> = ({ config, onChange }) => {
  const viewOnly = useWorkflowReadOnly();
  return (
    <Box className="workflow-canvas-dialog__config-panel">
      <FormControlLabel
        control={
          <Switch
            disabled={viewOnly}
            checked={config.noteRequired}
            onChange={(event) => onChange({ ...config, noteRequired: event.target.checked })}
          />
        }
        label="Require a reason when cancelling"
      />
      <TextField
        disabled={viewOnly}
        label="Default cancel note"
        size="small"
        fullWidth
        multiline
        minRows={3}
        value={config.defaultNote}
        onChange={(event) => onChange({ ...config, defaultNote: event.target.value })}
        placeholder="Optional note explaining why the case was cancelled"
      />
    </Box>
  );
};

export default WorkflowCancelPanel;
